// Auto generated file, do not manually modify!
// com.hotpads.satellite.web.api.web.landlord.v1.leadmanagement.SatelliteWebLandlordLeadManagementHandler

import type { QueryOptions, UseMutationOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useMutation, useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  SatelliteWebLandlordLeadManagementHandler_approveLead,
  SatelliteWebLandlordLeadManagementHandler_getScreeningCriteria,
  SatelliteWebLandlordLeadManagementHandler_getScreeningCriteria_Path,
  SatelliteWebLandlordLeadManagementHandler_leadManagementSearch,
  SatelliteWebLandlordLeadManagementHandler_leadManagementSearch_Path,
  SatelliteWebLandlordLeadManagementHandler_leadManagementStats,
  SatelliteWebLandlordLeadManagementHandler_leadManagementStats_Path,
  SatelliteWebLandlordLeadManagementHandler_leadManagementTable,
  SatelliteWebLandlordLeadManagementHandler_leadManagementTable_Path,
  SatelliteWebLandlordLeadManagementHandler_markAsTenant,
  SatelliteWebLandlordLeadManagementHandler_setScreeningCriteria,
} from '@zg-rentals/ts-satellite-client';

import type {
  SatelliteWebLandlordApproveLeadRequestDto,
  SatelliteWebLandlordApproveLeadResponseDto,
  SatelliteWebLandlordGetScreeningCriteriaRequestDto,
  SatelliteWebLandlordGetScreeningCriteriaResponseDto,
  SatelliteWebLandlordLeadManagementSearchRequestDto,
  SatelliteWebLandlordLeadManagementSearchResponseDto,
  SatelliteWebLandlordLeadManagementStatsRequestDto,
  SatelliteWebLandlordLeadManagementStatsResponseDto,
  SatelliteWebLandlordLeadManagementTableRequestDto,
  SatelliteWebLandlordLeadManagementTableResponseDto,
  SatelliteWebLandlordMarkAsTenantRequestDto,
  SatelliteWebLandlordMarkAsTenantResponseDto,
  SatelliteWebLandlordSetScreeningCriteriaRequestDto,
} from '@zg-rentals/ts-satellite-client';

export interface SatelliteWebLandlordLeadManagementHandler_approveLead_Args {
  postData: SatelliteWebLandlordApproveLeadRequestDto;
}

export type SatelliteWebLandlordLeadManagementHandler_approveLead_Options = UseMutationOptions<
  SatelliteWebLandlordApproveLeadResponseDto,
  unknown,
  SatelliteWebLandlordLeadManagementHandler_approveLead_Args
>;

export const useSatelliteWebLandlordLeadManagementHandler_approveLead = ({
  httpClient,
  ...options
}: Omit<SatelliteWebLandlordLeadManagementHandler_approveLead_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: SatelliteWebLandlordLeadManagementHandler_approveLead_Args) =>
      SatelliteWebLandlordLeadManagementHandler_approveLead(args.postData, httpClient),
  });
};

export type SatelliteWebLandlordLeadManagementHandler_getScreeningCriteria_Options = UseQueryOptions<
  SatelliteWebLandlordGetScreeningCriteriaResponseDto,
  unknown,
  SatelliteWebLandlordGetScreeningCriteriaResponseDto,
  readonly [string, SatelliteWebLandlordGetScreeningCriteriaRequestDto]
>;

const SatelliteWebLandlordLeadManagementHandler_getScreeningCriteria_GetKey = (
  postData: SatelliteWebLandlordGetScreeningCriteriaRequestDto,
) => [SatelliteWebLandlordLeadManagementHandler_getScreeningCriteria_Path, postData] as const;

export const SatelliteWebLandlordLeadManagementHandler_getScreeningCriteria_queryOptions = (
  postData: SatelliteWebLandlordGetScreeningCriteriaRequestDto,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: SatelliteWebLandlordLeadManagementHandler_getScreeningCriteria_GetKey(postData),
    queryFn: () => SatelliteWebLandlordLeadManagementHandler_getScreeningCriteria(postData, httpClient),
  }) as const satisfies QueryOptions;

export const useSatelliteWebLandlordLeadManagementHandler_getScreeningCriteria = (
  postData: SatelliteWebLandlordGetScreeningCriteriaRequestDto,
  {
    httpClient,
    ...options
  }: Omit<SatelliteWebLandlordLeadManagementHandler_getScreeningCriteria_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...SatelliteWebLandlordLeadManagementHandler_getScreeningCriteria_queryOptions(postData, { httpClient }),
    ...options,
  });
};
useSatelliteWebLandlordLeadManagementHandler_getScreeningCriteria.getKey =
  SatelliteWebLandlordLeadManagementHandler_getScreeningCriteria_GetKey;

export type SatelliteWebLandlordLeadManagementHandler_leadManagementSearch_Options = UseQueryOptions<
  SatelliteWebLandlordLeadManagementSearchResponseDto,
  unknown,
  SatelliteWebLandlordLeadManagementSearchResponseDto,
  readonly [string, SatelliteWebLandlordLeadManagementSearchRequestDto]
>;

const SatelliteWebLandlordLeadManagementHandler_leadManagementSearch_GetKey = (
  postData: SatelliteWebLandlordLeadManagementSearchRequestDto,
) => [SatelliteWebLandlordLeadManagementHandler_leadManagementSearch_Path, postData] as const;

export const SatelliteWebLandlordLeadManagementHandler_leadManagementSearch_queryOptions = (
  postData: SatelliteWebLandlordLeadManagementSearchRequestDto,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: SatelliteWebLandlordLeadManagementHandler_leadManagementSearch_GetKey(postData),
    queryFn: () => SatelliteWebLandlordLeadManagementHandler_leadManagementSearch(postData, httpClient),
  }) as const satisfies QueryOptions;

export const useSatelliteWebLandlordLeadManagementHandler_leadManagementSearch = (
  postData: SatelliteWebLandlordLeadManagementSearchRequestDto,
  {
    httpClient,
    ...options
  }: Omit<SatelliteWebLandlordLeadManagementHandler_leadManagementSearch_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...SatelliteWebLandlordLeadManagementHandler_leadManagementSearch_queryOptions(postData, { httpClient }),
    ...options,
  });
};
useSatelliteWebLandlordLeadManagementHandler_leadManagementSearch.getKey =
  SatelliteWebLandlordLeadManagementHandler_leadManagementSearch_GetKey;

export type SatelliteWebLandlordLeadManagementHandler_leadManagementStats_Options = UseQueryOptions<
  SatelliteWebLandlordLeadManagementStatsResponseDto,
  unknown,
  SatelliteWebLandlordLeadManagementStatsResponseDto,
  readonly [string, SatelliteWebLandlordLeadManagementStatsRequestDto]
>;

const SatelliteWebLandlordLeadManagementHandler_leadManagementStats_GetKey = (
  postData: SatelliteWebLandlordLeadManagementStatsRequestDto,
) => [SatelliteWebLandlordLeadManagementHandler_leadManagementStats_Path, postData] as const;

export const SatelliteWebLandlordLeadManagementHandler_leadManagementStats_queryOptions = (
  postData: SatelliteWebLandlordLeadManagementStatsRequestDto,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: SatelliteWebLandlordLeadManagementHandler_leadManagementStats_GetKey(postData),
    queryFn: () => SatelliteWebLandlordLeadManagementHandler_leadManagementStats(postData, httpClient),
  }) as const satisfies QueryOptions;

export const useSatelliteWebLandlordLeadManagementHandler_leadManagementStats = (
  postData: SatelliteWebLandlordLeadManagementStatsRequestDto,
  {
    httpClient,
    ...options
  }: Omit<SatelliteWebLandlordLeadManagementHandler_leadManagementStats_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...SatelliteWebLandlordLeadManagementHandler_leadManagementStats_queryOptions(postData, { httpClient }),
    ...options,
  });
};
useSatelliteWebLandlordLeadManagementHandler_leadManagementStats.getKey =
  SatelliteWebLandlordLeadManagementHandler_leadManagementStats_GetKey;

export type SatelliteWebLandlordLeadManagementHandler_leadManagementTable_Options = UseQueryOptions<
  SatelliteWebLandlordLeadManagementTableResponseDto,
  unknown,
  SatelliteWebLandlordLeadManagementTableResponseDto,
  readonly [string, SatelliteWebLandlordLeadManagementTableRequestDto]
>;

const SatelliteWebLandlordLeadManagementHandler_leadManagementTable_GetKey = (
  postData: SatelliteWebLandlordLeadManagementTableRequestDto,
) => [SatelliteWebLandlordLeadManagementHandler_leadManagementTable_Path, postData] as const;

export const SatelliteWebLandlordLeadManagementHandler_leadManagementTable_queryOptions = (
  postData: SatelliteWebLandlordLeadManagementTableRequestDto,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: SatelliteWebLandlordLeadManagementHandler_leadManagementTable_GetKey(postData),
    queryFn: () => SatelliteWebLandlordLeadManagementHandler_leadManagementTable(postData, httpClient),
  }) as const satisfies QueryOptions;

export const useSatelliteWebLandlordLeadManagementHandler_leadManagementTable = (
  postData: SatelliteWebLandlordLeadManagementTableRequestDto,
  {
    httpClient,
    ...options
  }: Omit<SatelliteWebLandlordLeadManagementHandler_leadManagementTable_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...SatelliteWebLandlordLeadManagementHandler_leadManagementTable_queryOptions(postData, { httpClient }),
    ...options,
  });
};
useSatelliteWebLandlordLeadManagementHandler_leadManagementTable.getKey =
  SatelliteWebLandlordLeadManagementHandler_leadManagementTable_GetKey;

export interface SatelliteWebLandlordLeadManagementHandler_markAsTenant_Args {
  postData: SatelliteWebLandlordMarkAsTenantRequestDto;
}

export type SatelliteWebLandlordLeadManagementHandler_markAsTenant_Options = UseMutationOptions<
  SatelliteWebLandlordMarkAsTenantResponseDto,
  unknown,
  SatelliteWebLandlordLeadManagementHandler_markAsTenant_Args
>;

export const useSatelliteWebLandlordLeadManagementHandler_markAsTenant = ({
  httpClient,
  ...options
}: Omit<SatelliteWebLandlordLeadManagementHandler_markAsTenant_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: SatelliteWebLandlordLeadManagementHandler_markAsTenant_Args) =>
      SatelliteWebLandlordLeadManagementHandler_markAsTenant(args.postData, httpClient),
  });
};

export interface SatelliteWebLandlordLeadManagementHandler_setScreeningCriteria_Args {
  postData: SatelliteWebLandlordSetScreeningCriteriaRequestDto;
}

export type SatelliteWebLandlordLeadManagementHandler_setScreeningCriteria_Options = UseMutationOptions<
  void,
  unknown,
  SatelliteWebLandlordLeadManagementHandler_setScreeningCriteria_Args
>;

export const useSatelliteWebLandlordLeadManagementHandler_setScreeningCriteria = ({
  httpClient,
  ...options
}: Omit<SatelliteWebLandlordLeadManagementHandler_setScreeningCriteria_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: SatelliteWebLandlordLeadManagementHandler_setScreeningCriteria_Args) =>
      SatelliteWebLandlordLeadManagementHandler_setScreeningCriteria(args.postData, httpClient),
  });
};
